import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {Button, FormControlLabel} from "@material-ui/core";
import {baseStyles, FIELD_SPACE, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import Space from "../commons/Space";
import {
  fetchActivities,
  fetchActivityQuestionOptions,
  fetchActivityQuestionsDropDown
} from "../../actions/activitiesActions";
import ValueHelper, {textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import {cloneDeep} from "lodash";
import {fetchBranches} from "../../actions/branchActions";
import {fetchCompanies, fetchCompanyLevels} from "../../actions/companyActions";
import {fetchUsers} from "../../actions/userActions";
import {
  fetchCountries,
  fetchLocalities,
  fetchNationalities,
  fetchRegions,
  fetchSubLocalities
} from "../../actions/locationAction";
import {fetchAgeGroup} from "../../actions/insightsActions";
import AutoCompleteView from "../commons/AutoCompleteView";
import {getArrayOfIds} from "../../utils/utils";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import constants from "../../constants";
import {ColorOrange, ColorSubTitle} from "src/styles/Colors";
import MapField, {MAP_EXTRA_HEIGHT} from "../commons/MapField";
import DialogView from "../commons/DialogView";
import InputLabel from "@material-ui/core/InputLabel";
import TextView from "../commons/TextView";
import AddLocationIcon from '@material-ui/icons/AddLocation';
import DeleteIcon from '@material-ui/icons/Delete';
import {FontWeightMedium} from "src/res/FontWeight";
import {ImageIcon} from "src/js/components/commons/ViewHelper";
import FieldSpace from "src/js/components/commons/FieldSpace";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FormHelperText from "@material-ui/core/FormHelperText";
import View from "src/js/components/commons/View";
import TouchableOpacity from "src/js/components/commons/TouchableOpacity";

const useStyles = () => ({
});

const CRITERIA_BRANCH = 1;
const CRITERIA_REGION = 2;
const CRITERIA_CITY = 3;
const CRITERIA_DISTRICT = 4;
const CRITERIA_GENDER = 5;
const CRITERIA_AGE_GROUP = 6;
const CRITERIA_NATIONALITY = 7;
const CRITERIA_COMPANY = 8;
const CRITERIA_CUSTOMERS = 10;
const CRITERIA_SELECTED_CUSTOMERS_ONLY = 11;
const CRITERIA_QUESTION = 12;
const CRITERIA_QUESTION_OPTION = 13;
const CRITERIA_VISIT = 14;
const CRITERIA_SPEND = 141;
const CRITERIA_GEOFENCES = 15;
const CRITERIA_COUNTRY = 16;

const CRITERIA_TYPE_DROP_DOWN = 1;
const CRITERIA_TYPE_SWITCH = 2;
const CRITERIA_TYPE_GEOFENCE_INPUT = 3;
const CRITERIA_TYPE_RADIO = 4;

const CRITERIA_CUSTOMER_VISITS_VALUES = [
  {id: 0, name: 'No Visits', min: 0, max: 0}, // string_pending
  {id: 1, name: 'One Visit', min: 1, max: 1}, // string_pending
  {id: 2, name: 'Visits Range', min: null, max: null, isInput: true} // string_pending
];

const MAX_QUESTIONS = 5;
const MAX_QUESTION_OPTIONS = 8;

class ManageActivityTargeting extends React.Component {

  constructor(props) {
    super(props);

    const {activityData} = this.props;
    if (!activityData.userTargeting) {
      activityData.userTargeting = {
        // targetingState: activityData.targetingState,
        targetingState: constants.activity.state.ACTIVE,
        branches: activityData.branches,
        cCountries: activityData.cCountries,
        cRegions: activityData.cRegions,
        cLocalities: activityData.cLocalities,
        cSubLocalities: activityData.cSubLocalities,
        cGeofences: activityData.cGeofences,
        cGender: activityData.cGender,
        cAgeGroupObjs: activityData.cAgeGroupObjs,
        cNationalities: activityData.cNationalities,
        cCompanies: activityData.cCompanies,
        cUsers: activityData.cUsers,
        isUserTargeted: activityData.isUserTargeted && (activityData.cUsers && activityData.cUsers.length > 0),
        cVisits: activityData.cVisits,
        cSpends: activityData.cSpends,
        cQuestions: activityData.cQuestions,
      };
    }
    const userTargeting = activityData.userTargeting;
    const isSection2Expanded = (userTargeting.cCountries && userTargeting.cCountries.length > 0)
      || (userTargeting.cRegions && userTargeting.cRegions.length > 0)
      || (userTargeting.cLocalities && userTargeting.cLocalities.length > 0)
      || (userTargeting.cSubLocalities && userTargeting.cSubLocalities.length > 0);
    const isSection3Expanded = userTargeting.cGeofences && userTargeting.cGeofences.length > 0;
    const isSection4Expanded = (userTargeting.cSpends && userTargeting.cSpends.length > 0);
    const isSection5Expanded = userTargeting.cQuestions && userTargeting.cQuestions.length > 0;
    const isSection6Expanded = (userTargeting.cUsers && userTargeting.cUsers.length > 0)
      || userTargeting.isUserTargeted;
    const isSection1Expanded = userTargeting.cGender
      || (userTargeting.cAgeGroupObjs && userTargeting.cAgeGroupObjs.length > 0)
      || (userTargeting.cNationalities && userTargeting.cNationalities.length > 0)
      // || (!isSection2Expanded && !isSection3Expanded && !isSection4Expanded)
    ;

    this.state = {
      reload: false,
      sections: [
        {id: 1, labelId: 'activity.manage.subUserDemographic', expand: true /*isSection1Expanded*/},
        {id: 2, labelId: 'activity.manage.subUserGeographic', expand: true /*isSection2Expanded*/},
        {id: 3, labelId: 'activity.manage.subUserGeofence', expand: true /*isSection3Expanded*/},
        {id: 4, labelId: 'activity.manage.subUserActions', expand: true /*isSection4Expanded*/},
        {id: 5, labelId: 'activity.subUserInterests', expand: true /*isSection5Expanded*/},
        {id: 6, labelId: 'activity.manage.subSpecificUsers', expand: true /*isSection6Expanded*/}
      ],
      showcase: activityData.showcase,
    };

    this.onToggleTargetingState = this.onToggleTargetingState.bind(this);

    this.userTargeting = userTargeting;
  }

  setupData() {
    this.appliedCriteria = {};
    this.activityCVisits = null;
    this.activityCSpends = null;
    this.setupCriteria();
    this.updateCriteria();
  }

  componentDidMount() {
    this.genders = [
      {'id': 0, 'name': this.context.intl.formatMessage({id: 'filter.allGender'})},
      {'id': 1, 'name': this.context.intl.formatMessage({id: 'filter.male'})},
      {'id': 2, 'name': this.context.intl.formatMessage({id: 'filter.female'})},
    ];
    this.criteriaCustomerSpendsValues = [
      {id: 0, name: this.context.intl.formatMessage({id: 'filter.noGamePlays'}), min: 0, max: 0},
      {id: 1, name: this.context.intl.formatMessage({id: 'filter.gamePlaysRange'}), min: null, max: null, isInput: true}
    ];
    this.setupData();

    const {fetchAgeGroup, fetchNationalities, fetchActivityQuestionsDropDown, fetchCountries, fetchRegions} = this.props;
    // fetchAgeGroup();
    // fetchNationalities();
    fetchActivityQuestionsDropDown();
    fetchCountries();
    // fetchRegions();

    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  updateState(fields) {
    this.setState(fields, () => {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
      this.timeoutHandler = setTimeout(() => {
        this.props.onDataUpdated(this.getData(true));
        this.timeoutHandler = null;
      }, 400);
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError) {
    let data = {
      targetingState: this.userTargeting.targetingState,
    };
    if (this.userTargeting.targetingState === constants.activity.state.ACTIVE) {
      let isUserTargeted = false;
      const selectedCustomersOnly = this.appliedCriteria[CRITERIA_SELECTED_CUSTOMERS_ONLY];
      if (selectedCustomersOnly && selectedCustomersOnly.length > 0) {
        isUserTargeted = selectedCustomersOnly[0];
      }
      data.isUserTargeted = isUserTargeted ? 1 : 0;
      const branches = this.appliedCriteria[CRITERIA_BRANCH];
      if (branches) {
        data.branches = branches;
        data.branchIds = getArrayOfIds(branches);
      }
      const cUsers = this.appliedCriteria[CRITERIA_CUSTOMERS];
      if (cUsers) {
        data.cUsers = cUsers;
        data.cUserIds = getArrayOfIds(cUsers);
      }

      if (!isUserTargeted) {
        const cCountries = this.appliedCriteria[CRITERIA_COUNTRY];
        if (cCountries) {
          data.cCountries = cCountries;
          data.cCountryIds = getArrayOfIds(cCountries);
        }
        const cRegions = this.appliedCriteria[CRITERIA_REGION];
        if (cRegions) {
          data.cRegions = cRegions;
          data.cRegionIds = getArrayOfIds(cRegions);
        }
        const cLocalities = this.appliedCriteria[CRITERIA_CITY];
        if (cLocalities) {
          data.cLocalities = cLocalities;
          data.cLocalityIds = getArrayOfIds(cLocalities);
        }
        const cSubLocalities = this.appliedCriteria[CRITERIA_DISTRICT];
        if (cSubLocalities) {
          data.cSubLocalities = cSubLocalities;
          data.cSubLocalityIds = getArrayOfIds(cSubLocalities);
        }
        const geofences = this.appliedCriteria[CRITERIA_GEOFENCES];
        if (geofences && geofences.length > 0) {
          data.cGeofences = geofences;
        }
        const selectedGender = this.appliedCriteria[CRITERIA_GENDER];
        let gender = null;
        if (selectedGender && selectedGender.length > 0) {
          gender = selectedGender[0].id;
        }
        if (gender) {
          data.cGender = gender;
        }
        const cAgeGroupObjs = this.appliedCriteria[CRITERIA_AGE_GROUP];
        if (cAgeGroupObjs) {
          data.cAgeGroupObjs = cAgeGroupObjs;
          data.cAgeGroups = getArrayOfIds(cAgeGroupObjs);
        }
        const cNationalities = this.appliedCriteria[CRITERIA_NATIONALITY];
        if (cNationalities) {
          data.cNationalities = cNationalities;
          data.cNationalityIds = getArrayOfIds(cNationalities);
        }
        const cCompanies = this.appliedCriteria[CRITERIA_COMPANY];
        if (cCompanies) {
          data.cCompanies = cCompanies;
          data.cCompanyIds = getArrayOfIds(cCompanies);
        }
        const cVisits = this.appliedCriteria[CRITERIA_VISIT];
        if (cVisits && cVisits.length > 0) {
          data.cVisits = Array.from(cVisits);
        }
        const cSpends = this.appliedCriteria[CRITERIA_SPEND];
        if (cSpends && cSpends.length > 0) {
          data.cSpends = Array.from(cSpends);
        }
        let effQuestions = null;
        const questions = this.appliedCriteria[CRITERIA_QUESTION];
        if (questions && questions.length > 0) {
          const questionOptionsMap = this.appliedCriteria[CRITERIA_QUESTION_OPTION];
          effQuestions = [];
          questions.forEach((question) => {
            const questionClone = cloneDeep(question);
            if (questionOptionsMap) {
              const subOptionsSelected = questionOptionsMap[question.id];
              if (subOptionsSelected) {
                questionClone.optionObjs = [];
                questionClone.options = [];
                subOptionsSelected.forEach((subItem) => {
                  questionClone.optionObjs.push(subItem);
                  questionClone.options.push(subItem.id);
                });
                effQuestions.push(questionClone);
              }
            }
          });
        }
        if (effQuestions) {
          data.cQuestions = effQuestions;
        }
      }
    }

    return {
      userTargeting: data,
      showcase: this.state.showcase
    };
  }

  render() {
    const {app, classes, isXS, activityData, canEnableShowcase} = this.props;
    const {sections, showcase} = this.state;
    const criteriaLength = this.criteria ? this.criteria.length : 0;
    const indexSplit = isXS ? criteriaLength : 1;
    return (
      <div className={classes.viewColumnFullWidthNoCenter1}>
        <div className={classes.viewRowFullWidthNoCenter}>
          <div className={classes.flexColumnNoCenter}>
            <div className={classes.formActivity}>
              <div>
                {this.criteria && this.criteria.map((item, index) => {
                  if (index >= indexSplit) {
                    return null;
                  }
                  return (
                    <div key={sections[item.sectionIndex].id} className={classes.viewColumnFullWidthNoCenter}>
                      {index > 0 ? <FieldSpace multiplier={.5} /> : null}
                      {this.getFormSectionHeaderView(sections[item.sectionIndex])}
                      {sections[item.sectionIndex].expand ?
                        this.getAllCriteriaView(item.criteria)
                        : null
                      }
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {indexSplit < criteriaLength ?
            <div className={classes.flexColumnNoCenter} style={{marginLeft: app.isLTR ? 2 * FIELD_SPACE : 0, marginRight: !app.isLTR ? 2 * FIELD_SPACE : 0}}>
              <div className={classes.formActivity}>
                <div>
                  {this.criteria && this.criteria.map((item, index) => {
                    if (index < indexSplit) {
                      return null;
                    }
                    return (
                      <div key={sections[item.sectionIndex].id} className={classes.viewColumnFullWidthNoCenter}>
                        {index > indexSplit ? <FieldSpace multiplier={.5} /> : null}
                        {this.getFormSectionHeaderView(sections[item.sectionIndex])}
                        {sections[item.sectionIndex].expand ?
                          this.getAllCriteriaView(item.criteria)
                          : null
                        }
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            : null
          }
        </div>

        {canEnableShowcase && (activityData.business.id === 1 || activityData.business.id === 2 || activityData.business.id === 3)
          && activityData.type !== constants.activity.types.OFFER
          && activityData.type !== constants.activity.types.VOUCHER
          && activityData.type !== constants.activity.types.QUESTION
          && activityData.type !== constants.activity.types.VISITOR_OPINION
          && activityData.type !== constants.activity.types.QUESTIONNAIRE
          && activityData.type !== constants.activity.types.SURVEY ?
          <React.Fragment>
            <div className={classes.viewRowNoCenter} style={{marginTop: isXS ? 20 : 24}}>
              <div className={classes.viewColumn}>
                <SectionHeaderView
                  labelId={'activity.showcaseCampaign'}
                  subLabelId={this.props.isEditing ? 'activity.showcaseCampaignHint1Edit' : 'activity.showcaseCampaignHint1'}
                  noBottomSpace={true}/>
                {/*<TextView color={ColorOrange} variant={'caption'}>*/}
                {/*  <FormattedMessage id={this.props.isEditing ? 'activity.showcaseCampaignHint2Edit': 'activity.showcaseCampaignHint2'}/>*/}
                {/*</TextView>*/}
              </div>
              <Switch
                checked={showcase}
                onChange={this.onChecked}
                id="showcase"
                name="showcase"
                color="primary"
              />
            </div>
            <FieldSpace multiplier={1}/>
          </React.Fragment>
          : null
        }
        {this.renderDialogView()}
      </div>
    );
  }

  renderDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    const {title, message, content, positiveText, onPositiveClicked, neutralText, onNeutralClicked} = dialogInfo;
    return (
      <DialogView
        classes={classes}
        show={showDialog}
        title={title}
        message={message}
        content={content}
        positiveText={positiveText}
        onPositiveClicked={onPositiveClicked}
        neutralText={neutralText}
        onNeutralClicked={onNeutralClicked}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog = () => {
    this.setState({showDialog: false, dialogInfo: null});
  };

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  openGeofenceDialog(criteria) {
    const mapView = this.getGeofenceView(criteria);
    const dialogInfo = {
      title: this.context.intl.formatMessage({id: 'activity.manage.selectGeofence'}),
      content: mapView,
      positiveText: this.context.intl.formatMessage({id: 'generic.save'}),
      onPositiveClicked: this.onPickGeofence.bind(this, criteria),
      neutralText: this.context.intl.formatMessage({id: 'generic.cancel'}),
      onNeutralClicked: this.hideDialog
    };
    this.showDialog(dialogInfo);
  }

  onPickGeofence = (criteria) => {
    if (this.selectedGeofence) {
      this.appliedCriteria[criteria.id] = [this.selectedGeofence];
      this.selectedGeofence = null;
    } else {
      this.appliedCriteria[criteria.id] = null;
    }
    this.hideDialog();
  }

  onResetGeofence = (criteria) => {
    this.appliedCriteria[criteria.id] = null;
    this.reloadView()
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <SectionHeaderView labelId={section.labelId} />
    );
  }

  onFormSectionToggle = (section) => {
    const {sections} = this.state;
    const index = sections.indexOf(section);
    const eSections = cloneDeep(sections);
    eSections[index].expand = !eSections[index].expand;
    this.setState({sections: eSections});
  }

  onToggleTargetingState = (event) => {
    const checked = event.target.checked;
    if (checked) {
      this.userTargeting.targetingState = constants.activity.state.ACTIVE;
    } else {
      this.userTargeting = {
        targetingState: constants.activity.state.DELETE
      };
      this.setupData();
    }
    this.updateCriteria();
  };

  setupCriteria() {
    if (this.userTargeting.branches && this.userTargeting.branches.length > 0) {
      this.appliedCriteria[CRITERIA_BRANCH] = this.userTargeting.branches;
    }
    if (this.userTargeting.cCountries && this.userTargeting.cCountries.length > 0) {
      this.appliedCriteria[CRITERIA_COUNTRY] = this.userTargeting.cCountries;
    }
    if (this.userTargeting.cRegions && this.userTargeting.cRegions.length > 0) {
      this.appliedCriteria[CRITERIA_REGION] = this.userTargeting.cRegions;
    }
    if (this.userTargeting.cLocalities && this.userTargeting.cLocalities.length > 0) {
      this.appliedCriteria[CRITERIA_CITY] = this.userTargeting.cLocalities;
    }
    if (this.userTargeting.cSubLocalities && this.userTargeting.cSubLocalities.length > 0) {
      this.appliedCriteria[CRITERIA_DISTRICT] = this.userTargeting.cSubLocalities;
    }
    if (this.userTargeting.cGeofences && this.userTargeting.cGeofences.length > 0) {
      const cGeofences = [];
      this.userTargeting.cGeofences.forEach((geofence) => {
        cGeofences.push(cloneDeep(geofence));
      });
      this.appliedCriteria[CRITERIA_GEOFENCES] = cGeofences;
    }
    if (this.userTargeting.cGender) {
      let gender = null;
      this.genders.forEach((item) => {
        if (item.id == this.userTargeting.cGender) {
          gender = item;
        }
      });
      this.appliedCriteria[CRITERIA_GENDER] = [gender];
    }
    if (this.userTargeting.cAgeGroupObjs && this.userTargeting.cAgeGroupObjs.length > 0) {
      this.appliedCriteria[CRITERIA_AGE_GROUP] = this.userTargeting.cAgeGroupObjs;
    }
    if (this.userTargeting.cNationalities && this.userTargeting.cNationalities.length > 0) {
      this.appliedCriteria[CRITERIA_NATIONALITY] = this.userTargeting.cNationalities;
    }
    if (this.userTargeting.cCompanies && this.userTargeting.cCompanies.length > 0) {
      this.appliedCriteria[CRITERIA_COMPANY] = this.userTargeting.cCompanies;
    }
    if (this.userTargeting.cUsers && this.userTargeting.cUsers.length > 0) {
      const users = [];
      this.userTargeting.cUsers.forEach((item) => {
        if (!item.isLocalModified) {
          item.name = item.mobileNumber ? '+'+ item.numberCode +'-'+ item.mobileNumber : 'Rab7#' + item.rab7Number;
          item.isLocalModified = true;
        }
        users.push(item);
      });
      this.appliedCriteria[CRITERIA_CUSTOMERS] = users;
    }
    if (this.userTargeting.isUserTargeted) {
      this.appliedCriteria[CRITERIA_SELECTED_CUSTOMERS_ONLY] = [true];
    }
    if (this.userTargeting.cVisits && this.userTargeting.cVisits.length > 0) {
      this.activityCVisits = [];
      const cVisit = this.userTargeting.cVisits[0];
      this.activityCVisits.push(cloneDeep(cVisit));

      let value = null;
      if (cVisit.min === 0 && cVisit.max === 0) {
        value = CRITERIA_CUSTOMER_VISITS_VALUES[0];
      } else if (cVisit.min === 1 && cVisit.max === 1) {
        value = CRITERIA_CUSTOMER_VISITS_VALUES[1];
      } else if (cVisit.min > 1 && cVisit.max > 1) {
        value = CRITERIA_CUSTOMER_VISITS_VALUES[2];
        value.min = cVisit.min;
        value.max = cVisit.max;
      }
      this.appliedCriteria[CRITERIA_VISIT] = value ? [value] : null;
    }
    if (this.userTargeting.cSpends && this.userTargeting.cSpends.length > 0) {
      this.activityCSpends = [];
      const cSpend = this.userTargeting.cSpends[0];
      this.activityCSpends.push(cloneDeep(cSpend));

      let value = null;
      if (cSpend.min === 0 && cSpend.max === 0) {
        value = this.criteriaCustomerSpendsValues[0];
      } else if (cSpend.min > 0 && cSpend.max > 0) {
        value = this.criteriaCustomerSpendsValues[1];
        value.min = cSpend.min;
        value.max = cSpend.max;
      }
      this.appliedCriteria[CRITERIA_SPEND] = value ? [value] : null;
    }
    const selectedOptions = {};
    if (this.userTargeting.cQuestions && this.userTargeting.cQuestions.length > 0) {
      this.appliedCriteria[CRITERIA_QUESTION] = this.userTargeting.cQuestions;
      this.userTargeting.cQuestions.forEach((item) => {
        if (item.optionObjs && item.optionObjs.length > 0) {
          selectedOptions[item.id] = item.optionObjs;
          // item.subOptionsSelected = [];
          // this.props.fetchActivityQuestionOptions(item.id);
          // this.appliedCriteria[CRITERIA_QUESTION_OPTION +'_'+ item.id] = item.optionObjs;
          // item.optionObjs.forEach((option) => {
          //   item.subOptionsSelected.push(option);
          // });
        }
      });
    }
    this.appliedCriteria[CRITERIA_QUESTION_OPTION] = selectedOptions;

    if (!this.criteriaBranches) {
      this.criteriaBranches = {
        id: CRITERIA_BRANCH,
        name: 'Branches', // string_pending
        endpoint: (search) => {
          this.props.fetchBranches(this.userTargeting.cBusinessId, search).then(this.endpointCallback.bind(this, CRITERIA_BRANCH)).catch(this.endpointCallback.bind(this, CRITERIA_BRANCH));
        },
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaCountries) {
      this.criteriaCountries = {
        id: CRITERIA_COUNTRY,
        name: this.context.intl.formatMessage({id: 'filter.countries'}),
        type: CRITERIA_TYPE_DROP_DOWN,
      };
    }
    if (!this.criteriaRegions) {
      this.criteriaRegions = {
        id: CRITERIA_REGION,
        name: this.context.intl.formatMessage({id: 'filter.regions'}),
        endpoint: (search) => {
          const countries = this.appliedCriteria[CRITERIA_COUNTRY];
          let countryIds = null;
          if (countries && countries.length > 0) {
            countryIds = getArrayOfIds(countries);
          }
          this.props.fetchRegions(search, countryIds).then(this.endpointCallback.bind(this, CRITERIA_REGION)).catch(this.endpointCallback.bind(this, CRITERIA_REGION));
        },
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaCities) {
      this.criteriaCities = {
        id: CRITERIA_CITY,
        name: this.context.intl.formatMessage({id: 'filter.cities'}),
        endpoint: (search) => {
          const countries = this.appliedCriteria[CRITERIA_COUNTRY];
          let countryIds = null;
          if (countries && countries.length > 0) {
            countryIds = getArrayOfIds(countries);
          }
          this.props.fetchLocalities(search, countryIds).then(this.endpointCallback.bind(this, CRITERIA_CITY)).catch(this.endpointCallback.bind(this, CRITERIA_CITY));
        },
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaDistricts) {
      this.criteriaDistricts = {
        id: CRITERIA_DISTRICT,
        name: this.context.intl.formatMessage({id: 'filter.districts'}),
        endpoint: (search) => {
          const countries = this.appliedCriteria[CRITERIA_COUNTRY];
          let countryIds = null;
          if (countries && countries.length > 0) {
            countryIds = getArrayOfIds(countries);
          }
          this.props.fetchSubLocalities(search, countryIds).then(this.endpointCallback.bind(this, CRITERIA_DISTRICT)).catch(this.endpointCallback.bind(this, CRITERIA_DISTRICT));
        },
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaGeofences) {
      this.criteriaGeofences = {
        id: CRITERIA_GEOFENCES,
        key: CRITERIA_GEOFENCES,
        type: CRITERIA_TYPE_GEOFENCE_INPUT
      };
    }
    if (!this.criteriaGender) {
      this.criteriaGender = {
        id: CRITERIA_GENDER,
        name: this.context.intl.formatMessage({id: 'filter.gender'}),
        type: CRITERIA_TYPE_RADIO,
      };
    }
    if (!this.criteriaAgeGroups) {
      this.criteriaAgeGroups = {
        id: CRITERIA_AGE_GROUP,
        name: this.context.intl.formatMessage({id: 'filter.ageGroups'}),
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaNationalities) {
      this.criteriaNationalities = {
        id: CRITERIA_NATIONALITY,
        name: this.context.intl.formatMessage({id: 'filter.nationalities'}),
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaCompanies) {
      this.criteriaCompanies = {
        id: CRITERIA_COMPANY,
        name: 'Companies', // string_pending
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaCustomers) {
      this.criteriaCustomers = {
        id: CRITERIA_CUSTOMERS,
        name: this.context.intl.formatMessage({id: 'filter.users'}),
        endpoint: (search) => {
          this.props.fetchUsers(search).then(this.endpointCallback.bind(this, CRITERIA_CUSTOMERS)).catch(this.endpointCallback.bind(this, CRITERIA_CUSTOMERS));
        },
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaSelectedCustomersOnly) {
      const name = this.context.intl.formatMessage({id: 'filter.targetSelectedUsers'});
      this.criteriaSelectedCustomersOnly = {
        id: CRITERIA_SELECTED_CUSTOMERS_ONLY,
        name: name,
        type: CRITERIA_TYPE_SWITCH
      };
    }
    if (!this.criteriaVisits) {
      this.criteriaVisits = {
        id: CRITERIA_VISIT,
        name: 'Customer Visits', // string_pending
        values: CRITERIA_CUSTOMER_VISITS_VALUES,
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaSpends) {
      this.criteriaSpends = {
        id: CRITERIA_SPEND,
        name: this.context.intl.formatMessage({id: 'filter.gamePlays'}),
        labelValue1: this.context.intl.formatMessage({id: 'filter.actionsFrom'}),
        labelValue2: this.context.intl.formatMessage({id: 'filter.actionsTo'}),
        values: this.criteriaCustomerSpendsValues,
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
    if (!this.criteriaQuestions) {
      this.criteriaQuestions = {
        id: CRITERIA_QUESTION,
        name: this.context.intl.formatMessage({id: 'filter.userInterests'}),
        endpoint: (search) => {
          this.props.fetchActivityQuestionsDropDown(search).then(this.endpointCallback.bind(this, CRITERIA_QUESTION)).catch(this.endpointCallback.bind(this, CRITERIA_QUESTION));
        },
        type: CRITERIA_TYPE_DROP_DOWN
      };
    }
  }

  endpointCallback = (criteriaId) => {
    this.setState({['isLoading'+ criteriaId]: false});
  };

  // getOptionCriteria(id, name) {
  //   const {activities} = this.props;
  //   const data = activities.questionOptions[id];
  //   if (!data || data.length === 0) {
  //     this.props.fetchActivityQuestionOptions(id);
  //   }
  //   const eId = CRITERIA_QUESTION_OPTION +'_'+ id;
  //   return {
  //     id: CRITERIA_QUESTION_OPTION,
  //     subId: id,
  //     eId: eId,
  //     name: name,
  //     type: CRITERIA_TYPE_DROP_DOWN
  //   };
  // }

  canTargetBranch() {
    // return (this.userTargeting.type === constants.activity.types.OFFER && !this.userTargeting.isVoucher)
    //   || this.userTargeting.type === constants.activity.types.DISCOUNT
    //   || this.userTargeting.type === constants.activity.types.BUYER_OPINION;
    return false;
  }

  updateCriteria() {
    this.criteria = null;
    const isTargetingEnabled = this.userTargeting.targetingState === constants.activity.state.ACTIVE;
    if (isTargetingEnabled) {
      this.criteria = [];

      const selectedValues = this.appliedCriteria[CRITERIA_SELECTED_CUSTOMERS_ONLY];
      const selectedCustomersOnly = selectedValues && selectedValues.length > 0 ? selectedValues[0] : false;

      // const criteria1 = [];
      // if (!selectedCustomersOnly) {
      //   criteria1.push(this.criteriaGender);
      //   criteria1.push(this.criteriaAgeGroups);
      //   criteria1.push(this.criteriaNationalities);
      //   // criteria1.push(this.criteriaCompanies);
      // }
      // if (criteria1 && criteria1.length > 0) {
      //   this.criteria.push({criteria: criteria1, sectionIndex: 0});
      // }

      const criteria2 = [];
      if (this.canTargetBranch()) {
        criteria2.push(this.criteriaBranches);
      }
      if (!selectedCustomersOnly) {
        criteria2.push(this.criteriaCountries);
        // criteria2.push(this.criteriaRegions);
        criteria2.push(this.criteriaCities);
        // criteria2.push(this.criteriaDistricts);
      }
      if (criteria2 && criteria2.length > 0) {
        this.criteria.push({criteria: criteria2, sectionIndex: 1});
      }

      const criteria21 = [];
      if (!selectedCustomersOnly) {
        criteria21.push(this.criteriaGeofences);
      }
      if (criteria21 && criteria21.length > 0) {
        this.criteria.push({criteria: criteria21, sectionIndex: 2});
      }

      // const criteria31 = [];
      // if (!selectedCustomersOnly) {
      //   criteria31.push(this.criteriaQuestions);
      // }
      // if (criteria31 && criteria31.length > 0) {
      //   this.criteria.push({criteria: criteria31, sectionIndex: 4});
      // }

      // const criteria4 = [];
      // criteria4.push(this.criteriaCustomers);
      // const selectedCustomers = this.appliedCriteria[CRITERIA_CUSTOMERS];
      // if ((selectedCustomers && selectedCustomers.length > 0) || selectedCustomersOnly) {
      //   criteria4.push(this.criteriaSelectedCustomersOnly);
      // }
      // if (criteria4 && criteria4.length > 0) {
      //   this.criteria.push({criteria: criteria4, sectionIndex: 5});
      // }
    }

    this.setState({reload: !this.state.reload});
  }

  getAllCriteriaView(allCriteria) {
    const {classes} = this.props;

    let criteriaViews = null;
    if (allCriteria && allCriteria.length > 0) {
      criteriaViews = [];
      allCriteria.forEach((item) => {
        criteriaViews.push(
          <React.Fragment>
            {this.getCriteriaView(item)}
            <FieldSpace />
          </React.Fragment>
        );
      });
    }
    return (
      <div className={classes.container}>
          {criteriaViews}
      </div>
    );
  }

  getCriteriaView(criteria) {
    if (criteria.type === CRITERIA_TYPE_RADIO) {
      return this.getRadioView(criteria);
    }
    if (criteria.type === CRITERIA_TYPE_DROP_DOWN) {
      return this.getDropDownView(criteria);
    }
    if (criteria.type === CRITERIA_TYPE_SWITCH) {
      return this.getSwitchView(criteria);
    }
    if (criteria.type === CRITERIA_TYPE_GEOFENCE_INPUT) {
      return this.getGeofenceCriteriaView(criteria);
    }
    return null;
  }

  getDropDownView(criteria) {
    const {app, branches, classes, activities} = this.props;

    let placeholderId = criteria.endpoint != null ? 'activity.manage.placeholderTargetingSelectSearch' : 'activity.manage.placeholderTargetingSelect';
    let multipleLimit = 100;
    let options = null;
    let hasSubOptions = false;
    let selectedSubValues = null;
    let lengthToSearch = 2;
    let searchTextLength = 1000;
    let hintId = null;
    let disabled = false;
    if (criteria.id === CRITERIA_BRANCH) {
      options = branches.paginated.data;
    } else if (criteria.id === CRITERIA_COUNTRY) {
      multipleLimit = 4;
      options = activities.countries;
      hintId = app.defaultLocale === 'ar' ? 'activity.searchInEnglishOnly' : null;
    } else if (criteria.id === CRITERIA_REGION) {
      options = activities.regions;
    } else if (criteria.id === CRITERIA_CITY) {
      multipleLimit = 10;
      disabled = !this.appliedCriteria[CRITERIA_COUNTRY] || this.appliedCriteria[CRITERIA_COUNTRY].length === 0;
      options = activities.localities;
      hintId = app.defaultLocale === 'ar' ? 'activity.searchInEnglishOnly' : null;
    } else if (criteria.id === CRITERIA_DISTRICT) {
      options = activities.subLocalities;
    } else if (criteria.id === CRITERIA_AGE_GROUP) {
      options = activities.ageGroups;
    } else if (criteria.id === CRITERIA_NATIONALITY) {
      options = activities.nationalities;
    } else if (criteria.id === CRITERIA_COMPANY) {
      options = activities.companies;
    } else if (criteria.id === CRITERIA_CUSTOMERS) {
      options = activities.users;
      placeholderId = 'activity.manage.placeholderTargetingSelectRab7No';
      searchTextLength = 7;
      lengthToSearch = 7;
    } else if (criteria.id === CRITERIA_GENDER) {
      options = this.genders;
      multipleLimit = 2;
    } else if (criteria.id === CRITERIA_VISIT) {
      options = CRITERIA_CUSTOMER_VISITS_VALUES;
      multipleLimit = 1;
    } else if (criteria.id === CRITERIA_SPEND) {
      options = this.criteriaCustomerSpendsValues;
      multipleLimit = 1;
    } else if (criteria.id === CRITERIA_QUESTION) {
      options = activities.questionsNOptions;
      multipleLimit = MAX_QUESTIONS;
      hasSubOptions = true;
      selectedSubValues = this.appliedCriteria[CRITERIA_QUESTION_OPTION];
    }
    // else if (criteria.id === CRITERIA_QUESTION_OPTION) {
    //   const subId = criteria.subId;
    //   options = activities.questionOptions[subId];
    //   multipleLimit = MAX_QUESTION_OPTIONS;
    // }
    const criteriaId = criteria.eId ? criteria.eId : criteria.id;

    const selectedValues = this.appliedCriteria[criteriaId];
    let selectedValue = null;
    if (selectedValues && selectedValues.length > 0) {
      selectedValue = selectedValues[0];
    }

    let values = null;
    let inputValue = null;
    if (multipleLimit > 1) {
      values = selectedValues;
      inputValue = this.state['search'+ criteriaId];
    } else {
      values = selectedValue;
      inputValue = selectedValue ? selectedValue.name : '';
    }

    return (
      <div key={criteriaId} className={classes.container} style={{paddingLeft: criteria.subId ? 40 : 0}}>
        <AutoCompleteView
          fullWidth
          disabled={disabled}
          hasSubOptions={hasSubOptions}
          multiple={multipleLimit > 1}
          multipleLimit={multipleLimit}
          key={''+ criteriaId}
          // filterOptions={FilterOptionsAny}
          label={criteria.name}
          placeholder={this.context.intl.formatMessage({id: placeholderId})}
          loading={this.state['isLoading'+ criteriaId]}
          searchTextLength={searchTextLength}
          options={options}
          selectedValues={values}
          selectedSubValues={selectedSubValues}
          inputValue={inputValue}
          onInputChange={(value) => {
            if (criteria.endpoint && value.length >= lengthToSearch) {
              if (criteriaId === CRITERIA_CUSTOMERS) {
                value = value.substr(0, searchTextLength);
              }
              this.setState({['search'+ criteriaId]: value, ['isLoading'+ criteriaId]: true}, () => {
                if (criteria.timeoutHandler) {
                  clearTimeout(criteria.timeoutHandler);
                  criteria.timeoutHandler = null;
                }
                criteria.timeoutHandler = setTimeout(() => {
                  criteria.endpoint(value);
                }, 300);
              });
            } else {
              this.setState({['search'+ criteriaId]: value, ['isLoading'+ criteriaId]: false}, () => {
                if (criteria.timeoutHandler) {
                  clearTimeout(criteria.timeoutHandler);
                  criteria.timeoutHandler = null;
                }
              });
            }
          }}
          onSelect={(value, subValue) => {
            const oldValues = this.appliedCriteria[criteriaId];
            let newValues = null;
            if (multipleLimit > 1) {
              newValues = value;
            } else {
              newValues = value ? [value] : null;
            }
            this.appliedCriteria[criteriaId] = newValues;
            if (newValues && newValues.length > 0) {
              const selectedValueL = newValues[0];
              if (selectedValueL.isInput) {
                selectedValueL.min = null;
                selectedValueL.max = null;
              }
            }
            if (criteriaId === CRITERIA_COUNTRY) {
              if (!newValues || newValues.length === 0) {
                this.appliedCriteria[CRITERIA_CITY] = null;
              }
            }
            if (criteriaId === CRITERIA_CUSTOMERS) {
              if (!newValues || newValues.length === 0) {
                this.appliedCriteria[CRITERIA_SELECTED_CUSTOMERS_ONLY] = null;
              }
              this.updateCriteria();
            }
            if (criteriaId === CRITERIA_QUESTION) {
              this.appliedCriteria[CRITERIA_QUESTION_OPTION] = subValue;
            }
            this.updateState({['search'+ criteriaId]: ''});
          }}
        />
        {hintId ? <div className={classes.flexRowNoCenter}><FormHelperText className={classes.helper}><FormattedMessage id={hintId}/></FormHelperText></div> : null}
        {selectedValue && selectedValue.isInput ?
          <div className={classes.container}>
            <Space horizontal={12}/>
            <div className={classes.flexRowNoCenter}>
              {/*<Space vertical={40}/>*/}
              <div className={classes.flex1}>
                <TextField
                  variant="filled"
                  fullWidth
                  required
                  size="small"
                  type="number"
                  id={"min" + criteriaId}
                  name={"min" + criteriaId}
                  label={criteria.labelValue1}
                  value={selectedValue.min}
                  InputProps={{disableUnderline: true}}
                  inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                  onChange={(event) => {
                    let value = event.target.value;
                    if (value < 0) {
                      value = 0;
                    } else if (value > constants.activity.VALUE_DEFAULT_MAX) {
                      value = constants.activity.VALUE_DEFAULT_MAX;
                    }
                    selectedValue.min = ValueHelper.getDecimalValue(value);

                    const max = selectedValue.max && selectedValue.max.length > 0 ? parseInt(ValueHelper.getEnglishValue(selectedValue.max)) : 0;
                    const min = selectedValue.min && selectedValue.min.length > 0 ? parseInt(ValueHelper.getEnglishValue(selectedValue.min)) : 0;
                    if (min > max) {
                      selectedValue.max = selectedValue.min;
                    }
                    this.reloadView();
                  }}
                  onKeyDown={textFieldIntegerOnKeyDown}
                />
              </div>
              <Space vertical={12}/>
              <div className={classes.flex1}>
                <TextField
                  variant="filled"
                  fullWidth
                  required
                  size="small"
                  type="number"
                  id={"max" + criteriaId}
                  name={"max" + criteriaId}
                  label={criteria.labelValue2}
                  value={selectedValue.max}
                  InputProps={{disableUnderline: true}}
                  inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                  onChange={(event) => {
                    let value = event.target.value;
                    if (value < 0) {
                      value = 0;
                    } else if (value > constants.activity.VALUE_DEFAULT_MAX) {
                      value = constants.activity.VALUE_DEFAULT_MAX;
                    }
                    selectedValue.max = ValueHelper.getDecimalValue(value);
                    selectedValue.max = value;
                    if (selectedValue.max && selectedValue.max.length > 0 && parseInt(ValueHelper.getEnglishValue(selectedValue.max)) < 1) {
                      selectedValue.max = null;
                    }
                    this.reloadView();
                  }}
                  onKeyDown={textFieldIntegerOnKeyDown}
                />
              </div>
            </div>
          </div>
          : null
        }
      </div>
    );
  }

  getSwitchView(criteria) {
    const {classes} = this.props;
    const selectedValues = this.appliedCriteria[criteria.id];
    let isSelected = selectedValues && selectedValues.length > 0 ? selectedValues[0] : false;

    return (
      <div className={classes.viewColumnFullWidth} key={criteria.id}>
        <div className={classes.flexRow}>
          <FormControlLabel
            style={{marginLeft: 12, marginRight: 12, marginTop: -8}}
            control={
              <Switch
                checked={isSelected}
                onChange={(event) => {
                  const checked = event.target.checked;
                    this.appliedCriteria[criteria.id] = [checked];
                    if (criteria.id === CRITERIA_SELECTED_CUSTOMERS_ONLY) {
                      this.updateCriteria();
                    }
                }}
                id={"switch"+ criteria.id}
                name={"switch"+ criteria.id}
                color="primary"
              />
            }
            labelPlacement="start"
            label={criteria.name}
          />
        </div>
      </div>
    );
  }

  getRadioView(criteria) {
    const {classes, app, isXS} = this.props;
    let options = null;
    if (criteria.id === CRITERIA_GENDER) {
      options = this.genders;
    }
    const selectedValues = this.appliedCriteria[criteria.id];
    const selectedValue = selectedValues && selectedValues.length > 0 ? selectedValues[0].id : this.genders[0].id;

    return (
      <div className={classes.viewRowFullWidth} key={criteria.id}>
        {options && options.map((item, index) => {
          const isSelected = item.id === selectedValue;
          const margin = index > 0 ? 12 : 0;
          return (
            <Button
              fullWidth={true}
              color={isSelected ? 'primary' : 'secondary'}
              size={isXS ? 'medium' : 'large'}
              variant={"outlined"}
              onClick={() => {
                this.appliedCriteria[criteria.id] = [item];
                this.updateState({reload: !this.state.reload});
              }}
              style={{marginRight: !app.isLTR ? margin : 0, marginLeft: app.isLTR ? margin : 0}}
              className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
              startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
              <FormattedMessage id={item.name} />
            </Button>
          );
        })}
      </div>
    );
  }

  getGeofenceCriteriaView(criteria) {
    const {classes, isXS, app} = this.props;
    const geofence = this.appliedCriteria[criteria.id] && this.appliedCriteria[criteria.id].length > 0 ? this.appliedCriteria[criteria.id][0] : null;

    let markers = null;
    let buttonRemove = null;
    let eRadius = 0;
    if (geofence) {
      markers = [{label: '', position: {lat: geofence.latitude, lng: geofence.longitude}}];
      buttonRemove = (
        <Button
          disableElevation
          className={classes.negativeButton}
          variant={'outlined'}
          color="secondary"
          size={'small'}
          style={{marginRight: app.isLTR ? 8 : 0, marginLeft: app.isLTR ? 0 : 8}}
          startIcon={<DeleteIcon />}
          onClick={this.onResetGeofence.bind(this, criteria)}>
          <FormattedMessage id={'generic.remove'} />
        </Button>
      );

      eRadius = geofence.radius;
      let decimalUpto = 1;
      if (eRadius >= 1000) {
        eRadius /= 1000;
        decimalUpto = 0;
      }
      eRadius = eRadius.toFixed(decimalUpto);
    }
    return (
      <div className={classes.inputField} style={{minHeight: 50}}>
        <div className={classes.flexRow}>
          <div className={classes.flexColumnNoCenter}>
            {geofence ?
              <div className={classes.flexColumnNoCenter} style={{marginTop: 6}}>
                <TextView numberOfLines={3} textAlign={'left'} variant={'body2'} fontWeight={FontWeightMedium}><FormattedHTMLMessage id={'activity.manage.geofenceCenter'} values={{latitude: ValueHelper.getDisplayValue(geofence.latitude, 4), longitude: ValueHelper.getDisplayValue(geofence.longitude, 4)}} /></TextView>
                <TextView numberOfLines={2} textAlign={'left'} variant={'body2'} fontWeight={FontWeightMedium}><FormattedHTMLMessage id={geofence.radius >= 1000 ? 'activity.manage.mapRadiusKmsB' : 'activity.manage.mapRadiusMeterB'} values={{value: eRadius}} /></TextView>
              </div>
              : <InputLabel>{this.context.intl.formatMessage({id: 'activity.manage.geofence'})}</InputLabel>
            }
          </div>
          <div className={classes.viewRow} style={{alignItems: 'center', marginLeft: 8}}>
            {/*{!isXS ? buttonRemove : null}*/}
            {buttonRemove}
            <Button
              disableElevation
              variant={'contained'}
              color="primary"
              size={'small'}
              startIcon={<AddLocationIcon />}
              onClick={() => this.openGeofenceDialog(criteria)}>
              <FormattedMessage id={geofence ? 'generic.edit' : 'generic.add'} />
            </Button>
          </div>
        </div>
        {geofence ?
          <div className={classes.flexColumnNoCenter} style={{marginTop: 8, marginBottom: 4}}>
            <View
              style={{position: 'relative', height: 300}}>
              <View style={{position: 'relative'}}>
                <MapField
                  readOnly={true}
                  width={300}
                  height={300}
                  isLTR={app.isLTR}
                  classes={classes}
                  center={{lat: geofence.latitude, lng: geofence.longitude}}
                  radius={geofence.radius}
                  radiusNeeded={true}
                  onCenterChanged={() => {}}
                  markers={markers}
                  styleMapContainer={{padding: 0}}
                />
              </View>
              <TouchableOpacity
                onClick={() => this.openGeofenceDialog(criteria)}
                style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}/>
            </View>
          </div>
          : null
        }
      </div>
    )
  }

  getGeofenceView(criteria) {
    const {classes, app, isXS} = this.props;
    let latLngText = null;
    let latitude = null;
    let longitude = null;
    let radius = null;
    if (this.appliedCriteria[criteria.id] && this.appliedCriteria[criteria.id].length > 0) {
      const geofence = this.appliedCriteria[criteria.id][0];
      if (geofence.latitude && geofence.longitude && geofence.radius) {
        latitude = geofence.latitude;
        longitude = geofence.longitude;
        radius = geofence.radius;
      }
    }
    let width = Math.min(window.appWidth - 48, 500);
    width = Math.min(window.appHeight - 282, width);
    const height = width + MAP_EXTRA_HEIGHT;
    return (
      <div className={classes.viewColumn} style={{minWidth: width, minHeight: height}}>
        <div style={{marginBottom: 4, marginLeft: 8, marginRight: 8}}>
          <TextView textAlign={'center'} variant={'body2'} color={ColorSubTitle}>{this.context.intl.formatMessage({id: 'activity.manage.hintSelectGeofence'})}</TextView>
        </div>
        <MapField
          styleMapContainer={{paddingLeft: isXS ? 0 : 8, paddingRight: isXS ? 0 : 8}}
          isLTR={app.isLTR}
          classes={classes}
          canDisable={true}
          radiusNeeded={true}
          width={width}
          radius={radius}
          center={latitude ? {lat: latitude, lng: longitude} : null}
          onCenterChanged={this.onMapChanged}
        />
      </div>
    );
  }

  onMapChanged = (data) => {
    if (data) {
      const latitude = data.center.lat;
      const longitude = data.center.lng;
      const radius = data.radius;
      this.selectedGeofence = {latitude, longitude, radius};
    } else {
      this.selectedGeofence = null;
    }
  };

}

ManageActivityTargeting.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object,
  app: PropTypes.object,
  branches: PropTypes.object,
  activities: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,

  fetchActivities: PropTypes.func,
  fetchCompanyLevels: PropTypes.func,
  fetchCompanies: PropTypes.func,
  fetchUsers: PropTypes.func,
  fetchNationalities: PropTypes.func,
  fetchCountries: PropTypes.func,
  fetchRegions: PropTypes.func,
  fetchLocalities: PropTypes.func,
  fetchSubLocalities: PropTypes.func,
  fetchBranches: PropTypes.func,
  fetchActivityQuestionsDropDown: PropTypes.func,
  fetchActivityQuestionOptions: PropTypes.func,
  fetchAgeGroup: PropTypes.func,
};

ManageActivityTargeting.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    branches: state.admin.branches,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActivities: (id, search, page, perPage, isLoadingDisabled, inDetail) => dispatch(fetchActivities(id, search, page, perPage, isLoadingDisabled, inDetail)),
    fetchBranches: (id, search) => dispatch(fetchBranches(id, search, 1, 100, true, null, true)),
    fetchCompanyLevels: () => dispatch(fetchCompanyLevels()),
    fetchCompanies: (search) => dispatch(fetchCompanies(search)),
    fetchUsers: (search) => dispatch(fetchUsers(search)),
    fetchNationalities: (search) => dispatch(fetchNationalities(search)),
    fetchCountries: (search) => dispatch(fetchCountries(search)),
    fetchRegions: (search, countryIds) => dispatch(fetchRegions(search, countryIds)),
    fetchLocalities: (search, countryIds) => dispatch(fetchLocalities(search, countryIds)),
    fetchSubLocalities: (search, countryIds) => dispatch(fetchSubLocalities(search, countryIds)),
    fetchActivityQuestionsDropDown: (search) => dispatch(fetchActivityQuestionsDropDown(search, 1, 100, true)),
    fetchActivityQuestionOptions: (id) => dispatch(fetchActivityQuestionOptions(id, true)),
    fetchAgeGroup: () => dispatch(fetchAgeGroup()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityTargeting))
);
